export default __webpack_public_path__ + "static/media/player-pause-circle.6867047a.svg";